module.exports = __webpack_public_path__ + "img/tiktok_code.a244f73f.png";